export const environment = {
  production: true,
  loginGwoUrl: 'https://moje.gwo.pl/uzytkownik',
  launcherApiUrl: 'https://launcher-multipodreczniki.apps.gwo.pl/api',
  name: 'prod',
  logging: false,
};
